(function () {
  const checkbox = document.getElementById('plan_toggle_check');
  const subscriptionToggle = document.querySelector('.subscription-toggle');

  const radioSub = document.querySelector('input[value="subscription_op"]');
  const radioOne = document.querySelector('input[value="oneime_op"]');

  if (!checkbox || !subscriptionToggle || !radioSub || !radioOne) {
    return;
  }

  checkbox.addEventListener('change', function () {
    // Toggle class
    subscriptionToggle.classList.toggle('active', checkbox.checked);

    if (checkbox.checked) {
      radioSub.checked = true;
      radioSub.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      radioOne.checked = true;
      radioOne.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /*
    if (typeof updateActiveAddon === 'function') {
      updateActiveAddon();
    }
    */
  });

  // Set initial state on page load
  subscriptionToggle.classList.toggle('active', checkbox.checked);
})();
